// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__kZrb7","rootSmall":"AddTileButton_rootSmall__u90uS"};